// import React from 'react';

const Menu = ({ children }) => {
   return (
      children
   );
};

export default Menu;
